import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SaidaEstoqueInserirComponent } from './saida-estoque-inserir.component';

const routes: Routes = [];

@NgModule({
  imports: [RouterModule.forChild([
    {path: '', component: SaidaEstoqueInserirComponent}
  ])],
  exports: [RouterModule]
})
export class SaidaEstoqueInserirRoutingModule { }
